<template>
  <div class="app-window">

  <ion-header>
    <ion-toolbar>
      <ion-title>EMAIL VERIFICATION</ion-title>
      <ion-buttons slot="start">
        <ion-back-button></ion-back-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <img src="/assets/banner-w700.png"/>

    <ion-card style="margin: 0">
      <ion-card-header>
        <ion-card-subtitle>Your verification code is emailed to you</ion-card-subtitle>
        <ion-card-title>Please Verify your email</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        It is important to have your Correct contact details for further communications. We have sent a Verification Code to your email.
        This should be with you almost immediately. If you didn’t received it, please check on your spam folders.
      </ion-card-content>
      <ion-card-content>
        <ion-item>
          <ion-label>Verification Code</ion-label>
          <ion-input placeholder="enter here" v-model="token"></ion-input>
        </ion-item>
        <ion-button v-on:click="proceed()">SUBMIT</ion-button>
      </ion-card-content>
      <ion-card-content>
        <ion-label :color="'dark'">
          <h3>Please enter the <strong>Verification Code</strong> sent to you on email and <strong>SUBMIT</strong></h3>
        </ion-label>
      </ion-card-content>
      <ion-card-content>
        <!--            <ion-item>-->
        <ion-label>
          If you did not receive the code, you can request to send the code, again or please go back and update the information and submit
        </ion-label>
<!--        <ion-button :color="'light'" :size="'small'" v-on:click="resend()">RESEND</ion-button>-->
        <!--            </ion-item>-->
      </ion-card-content>

    </ion-card>

  </ion-content>
  </div>
</template>

<script>
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButton,
  IonItem,
  IonContent,
  IonInput,
  IonBackButton,
  IonButtons,
  IonLabel,
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonCardTitle,
  IonCardSubtitle,
} from '@ionic/vue';
import {
  chevronForwardOutline
} from 'ionicons/icons';

import EoppService from "@/mixins/EoppService";
import router from "./Router";
import MessageService from "@/mixins/MessageService";
import gtmService from "@/services/GoogleTagService";

export default {
  name: 'EmailVerification',
  components: {
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButton,
    IonItem,
    IonContent,
    IonInput,
    IonBackButton,
    IonButtons,
    IonLabel,
    IonCard,
    IonCardHeader,
    IonCardContent,
    IonCardTitle,
    IonCardSubtitle,
  },
  mixins: [
    EoppService,
    MessageService
  ],
  data() {
    return {
      chevronForwardOutline,
      token: null
    };
  },
  mounted() {
    if (!this.quizAnswers) {
      this.back();
    }
  },
  methods: {
    back: async function () {
      await router.push({path: '/quiz'})
    },
    resend: async function () {

    },
    proceed: async function () {
      if (!this.token || this.token.trim().length == 0) {
        this.toast('Warning', 'Verification code is not Valid');
        return;
      }

      this.presentProgressIndicator( 4000 );
      this.signupId.token = this.token;

      this.postData('/signup/verify', this.signupId).then(async res => {
        if (res.data === 'SUCCESS') {
          this.signupInfo.verified = true;
                this.signupInfo.id = this.signupId.id;
                this.signupInfo.criteria = this.quizAnswers;

                gtmService.saveAcivity('enrol/enrolled', 'enrol/enrolled' );

                this.postData(`/enrol`, this.signupInfo).then(async vres => {
                  if (vres.data) {
                    this.signupInfo.results = vres.data;
                    localStorage.setItem('eopp-results', JSON.stringify(this.signupInfo));
                    await router.push({path: '/results'})
                  } else {
                    this.toast('Error', 'Error Loading Results');
                  }
                });
        } else {
          this.toast('Warning', 'Verification Failed, Please Check your details and try again');
        }
      }, err => {
        console.log(err);
        this.toast('Error', 'Verification Failed, Please Check your details and try again');
      });
    }
  }
}
</script>
<style>

</style>
